import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { selectEffectiveStaffRole, selectSelectedParishId } from 'redux/selectors/parishContext';

export default function Header() {
    const { defaultMerchant, userInfo, selectedParishName } = useSelector((state: RootState) => state.user);
    const selectedParishId = useSelector(selectSelectedParishId);
    const effectiveRole = useSelector(selectEffectiveStaffRole);
    const { name, address } = defaultMerchant || {};

    const parishTitle = selectedParishName || (defaultMerchant?.name ? `${name}${address ? ` - ${address}` : ''}` : null);

    return (
        <div
            style={{
                backgroundColor: '#142456',

                padding: '3vh',
                borderRadius: 6,
            }}
        >
            {parishTitle && (
                <Typography style={{ fontSize: 32 }} color={'white'} variant="h6">
                    {parishTitle}
                </Typography>
            )}
            {selectedParishId && effectiveRole ? (
                <Typography style={{ fontSize: 14, opacity: 0.85 }} color={'white'} variant="body2">
                    Role: {effectiveRole.replace(/_/g, ' ')}
                </Typography>
            ) : null}
            <div style={{ marginTop: '10vh' }}>
                <Typography style={{ fontSize: 25 }} color={'white'} variant="h5">
                    Welcome {userInfo?.name}
                </Typography>

                <Typography style={{ fontSize: 16 }} color={'white'} variant="h6">
                    {dayjs().format('MMMM, DD, YYYY')}
                </Typography>
            </div>
        </div>
    );
}
